import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../../../components/Footer';
import {
    Utensils,
    Building,
    GraduationCap,
    Stars,
    Briefcase,
    Clock,
    Bookmark,
    ArrowUpRight,
    Users,
    BookOpen,
    Award,
    Globe,
    Rocket,
    Target,
    Flag
} from 'lucide-react';
import { Link } from 'react-router-dom';
import Title from '../../../components/TitleComponent';


const diplomaCourses = [
    { name: "Diploma in Food Production", path: "diploma-in-food-production" },
    // /programmes/diploma-courses/best-bakery-and-confectionery-college-in-dehradun-uttarakhand
    { name: "Diploma in Bakery and Confectionary", path: "best-bakery-and-confectionery-college-in-dehradun-uttarakhand" },
    { name: "Diploma in Food & Beverage Service & Bar Tending", path: "diploma-in-food-and-beverage" },
    { name: "Diploma in Front Office", path: "diploma-in-front-office" },
    { name: "Diploma in Housekeeping", path: "diploma-in-housekeeping" }
];

const degreeCourses = [
    { name: "Bachelor of Hotel Management (BHM)", path: "bachelor/bhm-colleges-in-dehradun-uttarakhand" },
    { name: "Bachelor of Science – Hotel Management (B.Sc. – HM)", path: "bsc/hotel-management" },
    { name: "Master of Hotel Management (MHM)", path: "masters/hotel-management" },
    { name: "Master of Tourism and Travel Management (MTTM)", path: "masters/tourism-and-travel-management" }
];

const aviationCourses = [
    { name: "Diploma in Aviation Management (DAM)", path: "best-diploma-in-aviation-management-college-in-dehradun-uttarakhand" },
    { name: "Bachelor in Aviation Management", path: "bachelor/aviation-management" },
    { name: "Master in Aviation Management", path: "masters/aviation-management" }
];

const Stats = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 my-4 md:my-8 px-4"
    >
        {[
            { icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, number: "1000+", label: "Students Enrolled", color: "bg-blue-50" },
            { icon: <BookOpen className="w-6 h-6 md:w-8 md:h-8" />, number: "12+", label: "Programs Offered", color: "bg-green-50" },
            { icon: <Award className="w-6 h-6 md:w-8 md:h-8" />, number: "90%", label: "Placement Rate", color: "bg-purple-50" },
            { icon: <Globe className="w-6 h-6 md:w-8 md:h-8" />, number: "50+", label: "Industry Partners", color: "bg-orange-50" }
        ].map((stat, index) => (
            <motion.div
                key={index}
                className={`${stat.color} p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300`}
                whileHover={{ scale: 1.02 }}
            >
                <div className="text-[#0e4d38]">{stat.icon}</div>
                <h3 className="text-xl md:text-2xl font-bold mt-2 text-gray-800">{stat.number}</h3>
                <p className="text-gray-600 text-xs md:text-sm">{stat.label}</p>
            </motion.div>
        ))}
    </motion.div>
);



const AboutSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <BookOpen className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">About the School of Hotel Management and Tourism</h4>
        </div>
        <div className="space-y-4 text-gray-700">
            <p>Welcome to the esteemed School of Hotel Management and Tourism (SOHMT) at Maya Devi University, a premier institution renowned for its excellence in hotel management education within Dehradun. </p>

            <p>Our mission at SOHMT is to provide unparalleled education and training for students seeking success in the Hospitality & Tourism sector. With state-of-the-art infrastructure, a comprehensive curriculum, immersive learning opportunities, and a supportive atmosphere, we are dedicated to nurturing the holistic development of our students. Our goal is to empower individuals to thrive in diverse career paths with confidence. </p>

            <p>We are committed to delivering a multifaceted and integrated learning experience, continuously updating our curriculum to reflect the latest industry trends and innovations. Join us at SOHMT, where your journey to success in the Hospitality & Tourism industry begins.
            </p>
        </div>
    </motion.div>
);

const VisionMissionSection = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-lg"
        >
            <div className="flex items-center gap-3 mb-4 border-b pb-4">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Target className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-semibold text-[#0e4d38]">Vision & Mission of the School of Hotel Management & Tourism (SoHM)</h4>
            </div>
            <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>“Empowering Future Leaders”

                    </span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>"To be a premier institution recognized for excellence in hospitality and tourism education, shaping innovative and responsible leaders who contribute to a sustainable and dynamic global industry."</span>
                </li>
            </ul>
        </motion.div>

        <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-lg"
        >
            <div className="flex items-center gap-3 mb-4 border-b pb-4">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Flag className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-semibold text-[#0e4d38]">Mission</h4>
            </div>
            <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>"To be a premier institution recognized for excellence in hospitality and tourism education, shaping innovative and responsible leaders who contribute to a sustainable and dynamic global industry."</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>M2: "To foster a culture of sustainability and ethical practices in the hospitality and tourism industries, preparing graduates to make a positive impact on their communities and the environment."</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>M3: "To cultivate a diverse and inclusive learning environment that encourages creativity, critical thinking, and cultural awareness, enabling students to become adaptive leaders in the evolving landscape of hospitality and tourism."</span>
                </li>
            </ul>
        </motion.div>
    </div>
);


const WhySection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <BookOpen className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">Why Choose Us?</h4>
        </div>
        <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-lg"
        >
            <div className="flex items-center gap-3 mb-4 border-b pb-4">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Flag className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-semibold text-[#0e4d38]">Academic Excellence</h4>

            </div>
            <ul className="space-y-3 text-gray-700">
                <h4 className="text-xl font-semibold text-[#0e4d38]">Expert Faculty & Curriculum Design</h4>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Industry-experienced, domain-specific faculty with proven expertise</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Curriculum aligned with national and international hospitality education standards</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Collaborative course design by academic experts and industry professionals</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Choice Based Credit System (CBCS) for comprehensive assessment</span>
                </li>
            </ul>
            <ul className="space-y-3 text-gray-700 mt-2">
                <h4 className="text-xl font-semibold text-[#0e4d38]">Innovative Teaching Methodology</h4>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Advanced Learning Management System (LMS) integration</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Interactive classroom teaching approaches</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Experiential learning through Centers of Excellence</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Live industry projects integrated throughout the program</span>
                </li>
            </ul>
            <ul className="space-y-3 text-gray-700 mt-2">
                <h4 className="text-xl font-semibold text-[#0e4d38]">Personalized Student Development</h4>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>One-on-one progress monitoring and mentoring</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Holistic focus on intellectual, physical, and social growth</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Regular diagnostic assessments for career development</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Continuous core skill development and guidance</span>
                </li>
            </ul>




        </motion.div>



        <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-xl shadow-lg mt-4"
        >
            <div className="flex items-center gap-3 mb-4 border-b pb-4">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Flag className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-semibold text-[#0e4d38]">Industry Integration</h4>

            </div>
            <ul className="space-y-3 text-gray-700">
                <h4 className="text-xl font-semibold text-[#0e4d38]">Real-World Experience</h4>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Full-time industrial internship after third year</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Hands-on training in domain-specific technology


                    </span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Industry-relevant projects throughout the course duration</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Regular interaction with sector professionals</span>
                </li>
            </ul>
            <ul className="space-y-3 text-gray-700 mt-2">
                <h4 className="text-xl font-semibold text-[#0e4d38]">Career Advancement</h4>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Dedicated placement mentoring and career guidance</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Industry-academia gap bridging through updated syllabus</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Start-up and Innovation Lab access for entrepreneurial growth</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Professional development workshops and training</span>
                </li>
            </ul>
            <ul className="space-y-3 text-gray-700 mt-2">
                <h4 className="text-xl font-semibold text-[#0e4d38]">Key Differentiators</h4>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>State-of-the-art facilities for practical training</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Focus on entrepreneurship and innovation</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Comprehensive placement support system</span>
                </li>
                <li className="flex items-start gap-2">
                    <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                    <span>Blend of theoretical knowledge and practical skills</span>
                </li>
            </ul>




        </motion.div>

    </motion.div>
);
const DeansMessage = () => (
    <motion.div
        initial={{ opacity: 0, x: 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="bg-white p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
            <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                <Flag className="w-6 h-6" />
            </div>
            <h4 className="text-xl font-semibold text-[#0e4d38]">Dean’s Message </h4>
        </div>
        <div className="space-y-4 text-gray-700">
            <p>Dear Aspiring Hospitality Professionals,<br />
                Welcome to the School of Hotel Management & Tourism at Maya Devi University.

            </p>

            <p>As the hospitality industry evolves rapidly, our school stands at the forefront of educational innovation. We offer a unique blend of theoretical knowledge and practical exposure through our industry-integrated curriculum designed by leading experts in the field. </p>

            <p>Our strength lies in three core pillars: hands-on industry experience, personalized mentoring, and a global perspective. With state-of-the-art facilities and experienced faculty, we transform passionate students into industry-ready professionals who lead rather than follow.
            </p>
            <p>The Choice Based Credit System, coupled with our strong industry connections, ensures that our students receive not just education, but a launchpad for their careers. Our placement cell and industry partnerships provide excellent opportunities for internships and professional growth.
            </p>
            <p>Join us to transform your passion for hospitality into a rewarding career. At Maya Devi University, excellence isn't just taught – it's lived every day
            </p>
        </div>

        {/* <ul className="space-y-3 text-gray-700">
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>The Faculty of Engineering offers a range of programs that incorporate cutting-edge techniques, providing students with a comprehensive engineering education. </span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>We prioritize systematic evaluation and feedback to support continuous learning and improvement. </span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>To inspire and motivate students, the faculty creates various platforms where they can cultivate their creativity and innovation. </span>
            </li>
            <li className="flex items-start gap-2">
                <div className="w-2 h-2 mt-2 bg-[#23376c] rounded-full flex-shrink-0" />
                <span>Additionally, our strategic international partnerships offer students valuable opportunities for global exposure and participation  in collaborative research projects with leading institutions.  </span>
            </li>
        </ul> */}
    </motion.div>
);


const CourseCard = ({ course, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.1 }}
        className="group w-full"
    >
        <Link to={course.path}>
            <div className="bg-white p-3 md:p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col justify-between gap-2 md:gap-3">
                <div>
                    <div className="flex justify-between items-start">
                        <div className="p-2 bg-blue-50 rounded-lg">
                            <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                        </div>
                        <motion.div
                            whileHover={{ scale: 1.1 }}
                            className="p-1 md:p-2 rounded-full hover:bg-gray-100"
                        >
                            <ArrowUpRight className="w-3 h-3 md:w-4 md:h-4 text-gray-400 group-hover:text-[#0e4d38]" />
                        </motion.div>
                    </div>
                    <h3 className="text-sm md:text-lg font-semibold mt-2 md:mt-3 text-gray-800 group-hover:text-[#0e4d38] transition-colors line-clamp-2">
                        {course.name}
                    </h3>
                </div>
                <div className="flex items-center gap-2 md:gap-3 text-xs text-gray-500">
                    <div className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        <span>{course.name.includes('Master') ? '2 Years' : course.name.includes('Diploma') ? '2 Years' : course.name.includes('Bachelor of Science') ? '3 Years' : course.name.includes('Bachelor') ? '4 Years' : '1 Year'}</span>
                    </div>
                    <div className="flex items-center gap-1">
                        <Bookmark className="w-3 h-3" />
                        <span>{course.name.includes('Master') ? 'PG' : course.name.includes('Bachelor') ? 'UG' : 'Diploma'}</span>
                    </div>
                </div>
            </div>
        </Link>
    </motion.div>
);

const Department = ({ title, icon, courses }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {courses.map((course, index) => (
                <CourseCard key={index} course={course} index={index} />
            ))}
        </div>
    </motion.div>
);

const FeatureList = ({ title, items, icon }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-xl text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {items.map((item, index) => (
                <motion.div
                    key={index}
                    className="p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300"
                    whileHover={{ scale: 1.02 }}
                >
                    <div className="flex items-start gap-2">
                        <div className="w-2 h-2 mt-1.5 bg-[#23376c] rounded-full flex-shrink-0" />
                        <span className="text-gray-700 text-xs md:text-sm">{item}</span>
                    </div>
                </motion.div>
            ))}
        </div>
    </motion.div>
);

const HeroSection = () => (
    <div className="relative overflow-hidden bg-[#0e4d38] text-white py-8 md:py-16 px-4 md:px-6 rounded-xl mb-6 md:mb-8 mt-16 md:mt-20">
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-5xl"
        >
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 md:mb-4">
                School of Hotel Management
            </h1>
            <p className="text-sm md:text-lg text-gray-200 mb-4 md:mb-6 max-w-3xl">
                Cultivating hospitality excellence through hands-on learning and industry-focused education.
                Join us in shaping the future of hospitality management.
            </p>
            <Link to="https://admission.maya.edu.in/">
                <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="bg-white text-[#0e4d38] px-4 md:px-6 py-2 md:py-3 rounded-full text-sm md:text-base font-semibold flex items-center gap-2 group"
                >
                    Apply Now
                    <Rocket className="w-3 h-3 md:w-4 md:h-4 group-hover:translate-x-1 transition-transform" />
                </motion.button>
            </Link>
        </motion.div>
    </div>
);

const HotelManagement = () => {
    return (
        <div className="min-h-screen bg-gray-50 font-poppins">
            <Title canonicalPath="/programmes/ug-courses/hotel-management-and-tourism" />
            <Title title="School of Tourism and Hotel Management at MDU" description="Join the School of Tourism and Hotel Management at MDU, Dehradun. Gain expertise in tourism, hospitality, and hotel management for a successful career." />
            <div className="max-w-7xl mx-auto pt-16 md:pt-20 pb-8 md:pb-16 px-4 space-y-6 md:space-y-8">
                <HeroSection />
                <Stats />
                <AboutSection />
                <VisionMissionSection />
                <WhySection />
                <DeansMessage />
                <div className="space-y-6 md:space-y-8">
                    {/* <Department
                        title="Diploma Programs"
                        icon={<GraduationCap className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={diplomaCourses}
                    /> */}
                    <Department
                        title="Degree Programs"
                        icon={<Building className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={degreeCourses}
                    />
                    {/* <Department
                        title="Aviation Programs"
                        icon={<Utensils className="w-5 h-5 md:w-6 md:h-6" />}
                        courses={aviationCourses}
                    /> */}
                </div>

                <div className="space-y-6 md:space-y-8">
                    <FeatureList
                        title="USPs"
                        icon={<Stars className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Industry-Experienced Faculty",
                            "State-of-the-art Training Kitchen",
                            "Hands-on Training in Hotel Operations",
                            "International Culinary Programs",
                            "Industry Partnerships with Leading Hotels",
                            "Regular Industry Visits",
                            "Professional Internship Programs",
                            "Modern Computer Labs",
                            "Well-equipped Housekeeping Labs",
                            "Front Office Training Center",
                            "Food & Beverage Service Labs",
                            "Guest Lectures by Industry Experts"
                        ]}
                    />

                    <FeatureList
                        title="Career Options"
                        icon={<Briefcase className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Hotel General Manager",
                            "Restaurant Manager",
                            "Executive Chef",
                            "Food & Beverage Director",
                            "Front Office Manager",
                            "Housekeeping Manager",
                            "Event Manager",
                            "Cruise Line Operations",
                            // "Aviation Hospitality",
                            "Resort Management",
                            "Catering Manager",
                            "Hotel Consultant"
                        ]}
                    />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default HotelManagement;